module.exports = __webpack_public_path__ + "static/media/8-5.b6f2333a.mp3";